var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDonwloadBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3556,
    cy: 11.6883,
    r: 11.0009,
    stroke: "#0C1C33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5231 11.4976C17.3122 11.4976 17.1095 11.576 16.9473 11.725L13.6225 14.94V7.41209C13.6225 6.9808 13.2576 6.62793 12.8116 6.62793C12.3656 6.62793 12.0007 6.9808 12.0007 7.41209V15.0419L8.67587 11.8268C8.3596 11.521 7.8487 11.521 7.53247 11.8268C7.21625 12.1327 7.21621 12.6267 7.53247 12.9325L12.1872 17.4414C12.3413 17.5904 12.544 17.6688 12.763 17.6688C12.982 17.6688 13.1847 17.5825 13.3388 17.4414L18.099 12.8384C18.4152 12.5326 18.4152 12.0385 18.099 11.7327C17.9368 11.5681 17.7258 11.4976 17.5231 11.4976Z",
    fill: "#0C1C33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDonwloadBtn);
export default __webpack_public_path__ + "static/media/ic-donwload-btn.cb13e006880130985cc93f876a3c027d.svg";
export { ForwardRef as ReactComponent };